<template>
  <f7-block>
    <f7-row>
      <f7-col width="50">
        <NutritionPlanList />
      </f7-col>
      <f7-col width="50">
        <div v-if="!loadedGIS">
          <div class="loadingFalse">
            <div class="preloader" />
          </div>
        </div>
        <div v-else>
          <GISWMSMap
            :zoom="zoom"
            :name-map="mainMap"
            :layer="layer"
            :index="'NDVI'"
            :center="center"
            :bbox="bbox"
            :height="'445px'"
          />
        </div>
      </f7-col>
    </f7-row>
  </f7-block>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NutritionPlanList from '../../wizardNutrition/nutritionPlanList/index.vue';
import GISWMSMap from '../../Gis/GISWMSMap/index.vue';
import Api from '../../../services/Api';

export default {
  name: 'Nutrition',
  components: {
    GISWMSMap,
    NutritionPlanList,
  },
  data() {
    return {
      loadedGIS: false,
      zoom: 17,
      mainMap: 'nutrition',
      layer: {
        name: 'nutrition',
        visible: false,
        timeDimension: true,
        baseUrl: Api.getGeoServerProjectWorkSpace(),
        options: {
          layers: '',
          format: 'image/png',
          transparent: true,
          styles: '',
        },
      },
      center: {},
      ws: Api.getGeoServerWorkspace(),
      bbox: {},
    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation', 'treeLocations']),
    ...mapState('Gis', ['currentBoundsWMSLayer']),
  },
  async beforeMount() {
    try {
      this.layer.options.layers = `${this.ws}:${this.currentPlantation.sectorId}`;
      this.center = { ...this.currentPlantation.coordinates };
      await this.fetchLocationsByPlantation();
      await this.boundsWMSLayer(`timacagro:${this.currentPlantation.sectorId}`);
      this.bbox = { ...this.currentBoundsWMSLayer.coverage.latLonBoundingBox };
      this.center = { ...this.currentPlantation.coordinates };
      this.loadedGIS = true;
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    }
  },
  methods: {
    ...mapActions('Plantation', ['fetchLocationsByPlantation']),
    ...mapActions('Gis', ['boundsWMSLayer']),
  },
};
</script>

<style lang="scss" scoped>
@import './Nutrition.styles.scss';
</style>
